import { API } from '@/api/API';
export function upsertUserAndGetId(payload, loggedIn) {
    const args = {
        embed: 'identity',
        body: payload,
    };
    const request = loggedIn ? API.put('my/user', args) : API.post('user', args);
    return request
        .then((response) => response.identity._data[0].id)
        .catch((e) => {
        if (e.response?.status === 409 && e.response.data._data[0]._extra) {
            // Ignore conflict status codes. This occurs when updating a password-protected user.
            return e.response.data._data[0]._extra.identity_id;
        }
        else {
            throw e;
        }
    });
}
